import { Component } from '@angular/core';
import { CheckCellRendererComponent } from './check-cell-renderer.component';

@Component({
	selector: 'app-readonly-check-cell-renderer',
	templateUrl: './readonly-check-cell-renderer.component.html',
	styleUrls: ['./check-cell-renderer.component.scss'],
})
export class ReadonlyCheckCellRendererComponent extends CheckCellRendererComponent {}
